import { Typography } from "@mui/material"


const Header = () => {
  return (
    <div style={{
      marginTop: '3rem',
      display: 'block',
    }}>
      <Typography variant="h3" sx={{ color: '#EDEBF7' }}>
        Hi. <strong style={{ fontStyle: 'italic' }}>Faruk</strong> here!
      </Typography>
      <Typography variant="h5" sx={{ color: "#EDEBF7" }}>
        Full Stack Web Developer
      </Typography>
    </div>
  )
}

export default Header